// Plays a guided tour (driver.js) from the steps a ViewComponents::Tours
// presenter put on the page. The packs that use it only decide when it starts:
// packs/race_director_tour.js for the dashboard, packs/form_tour.js for the
// longer forms.
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '../stylesheets/guided_tour';

// The first element matching +selector+ that is actually laid out, if any. A
// target that is in the page but not shown (a form section that hasn't opened
// yet) would otherwise get a zero-sized spotlight in the corner; returning
// nothing makes driver.js center the card instead.
const visibleElement = (selector) => (
  Array.from(document.querySelectorAll(selector))
    .find((element) => element.getClientRects().length > 0)
);

const toDriverStep = (step) => {
  const element = step.target && visibleElement(step.target);

  return {
    element,
    popover: {
      title: step.title,
      description: step.description,
      side: step.side || 'right',
      align: 'start',
      onPopoverRender: step.cta && ((popover) => {
        const link = document.createElement('a');
        link.href = step.cta.href;
        link.textContent = step.cta.label;
        link.className = 'btn btn-secondary btn-sm guided-tour__cta';
        if (step.cta.newTab) {
          link.target = '_blank';
          link.rel = 'noopener';
        }
        popover.footerButtons.appendChild(link);
        popover.wrapper.classList.add('guided-tour--with-cta');
        popover.nextButton.classList.add('guided-tour__quiet-btn');
      }),
    },
  };
};

export const startTour = (config, { onDestroyed } = {}) => {
  const tour = driver({
    popoverClass: 'guided-tour',
    showProgress: true,
    progressText: config.buttons.progress,
    nextBtnText: config.buttons.next,
    prevBtnText: config.buttons.previous,
    doneBtnText: config.buttons.done,
    steps: config.steps.map(toDriverStep),
    onDestroyed,
  });

  tour.drive();
  return tour;
};
